import { render, staticRenderFns } from "./ModalDicionario.vue?vue&type=template&id=91f4da40&"
import script from "./ModalDicionario.vue?vue&type=script&lang=js&"
export * from "./ModalDicionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports